import scene0 from "@/components/scenes/scene0.vue";


const scenes ={
    scene0,

}
export default scenes
